/** @jsx jsx */
import { jsx } from '@compiled/react';
import Tooltip from '@atlaskit/tooltip';
import { cssMap } from '@atlaskit/css';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	name: string;
	uri: string;
};

export const CardPriority = ({ name, uri }: Props) => {
	const { formatMessage } = useIntl();
	const label = formatMessage(messages.priorityTooltip, { priorityLevel: name });

	return (
		<Tooltip content={label}>
			<img alt={label} css={styles.root} src={uri} />
		</Tooltip>
	);
};

export default CardPriority;

const styles = cssMap({
	root: {
		display: 'flex',
		height: '16px',
		width: '16px',
		// These styles allow elements to receive pointer events even with the use of the
		// InteractionLayer component in the board card component. The InteractionLayer
		// component is used to create a clickable area for the card, but we want to
		// ensure that certain elements within the card can still receive pointer events.
		position: 'relative',
		pointerEvents: 'auto',
	},
});
